const prefix = '@modalConfirm';

export const SHOW_MODAL_CONFIRM = `${prefix}/SHOW_MODAL_CONFIRM`;
export const HIDE_MODAL_CONFIRM = `${prefix}/HIDE_MODAL_CONFIRM`;
